import { useState, useEffect } from 'react';
import { useUserContext } from '../../../hooks/useUserContext';
import { useTranslation } from 'react-i18next';
import ImageMap from '../../welten/ImageMap';
import "./Kindeswohl.css";

export default function SexuelleSelbstbestimmung({oldAndNewScore}) {
    const { t } = useTranslation();
    //variables for score and state updating
    const { games, updateGames, calculateScore, score, language } = useUserContext();
    const sexuelle_selbstbestimmung = games.sexuelle_selbstbestimmung;
    const max_points = games.sexuelle_selbstbestimmung.points_max;

    //set up image map variables
    var imgSrc;
    switch(language) {
      case 'de':
        imgSrc = "SexuelleSelbstbestimmung.png";
        break;
      case 'fr':
        imgSrc = "SexuelleSelbstbestimmung_fr.png";
        break;
      case 'it':
        imgSrc = "SexuelleSelbstbestimmung_it.png";
        break;
    }
    const height = window.innerHeight*0.6;
    const imgWidth = (height/1122)*3158;
    const viewbox = "0 0 " + imgWidth.toString() + " " + height.toString();
    const factor = height/1122;
    const imgMap = {
        imgSrc: imgSrc,
        areas: [
          {
            id: 1,
            name: 'sexuelle_selbstbestimmung1',
            type: 'rect',
            x: 744,
            y: 169,
            width: 2229,
            height: 124,
          },
          {
            id: 2,
            name: 'sexuelle_selbstbestimmung2',
            type: 'rect',
            x: 744,
            y: 295,
            width: 2229,
            height: 115,
          },
          {
            id: 3,
            name: 'nope',
            type: 'rect',
            x: 744,
            y: 400,
            width: 2229,
            height: 115,
          },
          {
            id: 4,
            name: 'sexuelle_selbstbestimmung3',
            type: 'rect',
            x: 744,
            y: 524,
            width: 2229,
            height: 127,
          },
          {
            id: 5,
            name: 'nope',
            type: 'rect',
            x: 744,
            y: 650,
            width: 2229,
            height: 121,
          }
        ],
    }

    const [wimmelbilder, setWimmelbilder] = useState({
      sexuelle_selbstbestimmung1: false,
      sexuelle_selbstbestimmung2: false,
      sexuelle_selbstbestimmung3: false,
    });

    const [text, setText] = useState(t('sexuelle_selbstbestimmung.start_text'));

    const clicked = (event, name) => {
        if (name!=="nope") {
            setWimmelbilder(wimmelbilder => ({...wimmelbilder, [name]: true}));
            event.target.id="active";
            show_message("good");
        } else if (name === "nope") {
            event.target.id="wrong";
            show_message("bad");
        };
        
    };

    const [wimmelbild_msg, setWimmelbildMsg] = useState("");
    const show_message = (state) => {
        if (state === "good") {
            setWimmelbildMsg(t('sexuelle_selbstbestimmung.correct'));
        } else if (state === "bad") {
            setWimmelbildMsg(t('sexuelle_selbstbestimmung.wrong'));
        };
        document.getElementById("wimmelbild_message").style.display = "flex";
        setTimeout(() => document.getElementById("wimmelbild_message").style.display="none", 1000);
    };

    useEffect(() => {
        let finished_temp = true;
        for (const value of Object.values(wimmelbilder)) {
            if (value === false) {
                finished_temp = false;
            };
        };
        if (finished_temp === true) {
            setText(t('sexuelle_selbstbestimmung.finish_text'));
            const sexuelle_selbstbestimmung_new = { ...sexuelle_selbstbestimmung, state: 'done', points_achieved: max_points };
            const games_new = { ...games, sexuelle_selbstbestimmung: sexuelle_selbstbestimmung_new };
            updateGames(games_new);
            const current_game = "sexuelle_selbstbestimmung";
            let total_score = calculateScore(current_game);
            total_score += max_points;
            const oldScore = score;
            const newScore = total_score;
            oldAndNewScore(oldScore, newScore);
            //updateScore(total_score);
            setTimeout(() => {
                setWimmelbildMsg(t('sexuelle_selbstbestimmung.finished'));
                document.getElementById("wimmelbild_message").style.display="flex";
                }
                , 1500);
        };
    },[wimmelbilder]);

    return (
        <div className="wimmelbild">
            <h2>{text}</h2>
            <div className="wrapper_wimmelbild" style={{ width: "100%", height: "65vh", overflowX: "auto", overflowY: "auto" }}>
                <ImageMap clicked={clicked} factor={factor} imgWidth={imgWidth} viewbox={viewbox} height={height} imgMap={imgMap} folder="game"/>
            </div>
            <div className="wimmelbild_message" id="wimmelbild_message">
                <p>{wimmelbild_msg}</p>
            </div>
        </div>
    )
}